import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import ML_logo from "../../img/MotMärk26.jpg";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import AOK from "../../img/NollK/A2026.png";
import AEOK from "../../img/NollK/AE2026.png";
import Bof from "../../img/NollK/BOF2026.png";
import Dnollk from "../../img/NollK/D2026.png";
import EOK from "../../img/NollK/E2026.png";
import Fnollk from "../../img/NollK/F2026.png";
import Gos from "../../img/NollK/GOS26.png";
import Hnollk from "../../img/NollK/H2026.png";
import Inollk from "../../img/NollK/I2026.png";
import Nollkit from "../../img/NollK/IT2026.png";
import Kok from "../../img/NollK/K2026.png";
import Mnollk from "../../img/NollK/m.png";
import Sjo from "../../img/NollK/SJO2026.jpg";
import TBK from "../../img/NollK/TBK2026.png";
import Tdnollk from "../../img/NollK/TD26.png";
import Vok from "../../img/NollK/V2026.png";
import Zok from "../../img/NollK/z.png";

import NollKCard from "../NollKCard";
import { titel, text1, text2, divider, flexCenter } from "../../style.js";

class NollK extends Component {
  render() {
    return (
      <Container style={paddingTop}>
        <Row lg={2} md={2} sm={1} xs={1} style={{ marginTop: "50px" }}>
          <Col>
            <div>
              <h1 style={titel}>CHALMERS MOTTAGNINGSKOMMITTÉER</h1>
              <div style={text2}>
                <p>
                  MK har hand om de centrala arrangemangen under mottagningen,
                  men utöver det så har varje sektion sin egen
                  Mottagningskommitté, NollK. Respektive sektions NollK
                  arrangerar en egen mottagningen för sektionens Nollan.
                </p>
                <p>
                  Det finns 17 mottagningskommittéer på Chalmers som tillsammans
                  med MK spenderar hela året på att förbereda för de nya Nollan
                  som anländer varje höst.
                </p>
                <p>
                  Hitta vilken mottagningskommitté som ansvarar för ditt program
                  nedan, och läs mer på respektives hemsida genom att klicka på
                  loggan.
                </p>
              </div>
            </div>
          </Col>
          <Col style={flexCenter}>
            <img
              src={ML_logo}
              style={{ width: "60%" }}
              alt={'Hjärta med texten "Mottagningen Chalmers Studentkår"'}
            ></img>
          </Col>
        </Row>
        <Row style={paddingStyle}>
          <div style={text1}>NollK</div>
        </Row>
        <Row style={divider}></Row>
        <Row
          xs={1}
          sm={1}
          md={2}
          lg={2}
          style={{ gridRowGap: "20px", marginTop: "10px" }}
        >
          <Col style={colStyle}>
            <NollKCard
              ImageSrc={AOK}
              Title={"AØK"}
              Web={"https://www.atek.chalmers.se/sektionen/kommitteer/aok/"}
              Program={`Arkitektur 300 hp
              Arkitektur och teknik 300 hp`}
            />
          </Col>
          <Col style={colStyle}>
            <NollKCard
              ImageSrc={AEOK}
              Title={"ÆØK"}
              Web={"https://www.ae-chalmers.com/ae0k"}
              Program={`Affärsutveckling och entreprenörskap 180 hp`}
            />
          </Col>
          <Col style={colStyle}>
            <NollKCard
              ImageSrc={Bof}
              Title={"bØf"}
              Web={
                "https://mottagning.kfkb.se/"
              }
              Program={`Bioteknik 300 hp`}
            />
          </Col>
          <Col style={colStyle}>
            <NollKCard
              ImageSrc={Dnollk}
              Title={"DNollK"}
              Web={"https://dnollk.se"}
              Program={`Datateknik 300 hp`}
            />
          </Col>
          <Col style={colStyle}>
            <NollKCard
              ImageSrc={EOK}
              Title={"EØK"}
              Web={"https://e0k.se"}
              Program={`Elektroteknik 300 hp
            Medicinteknik 300 hp`}
            />
          </Col>
          <Col style={colStyle}>
            <NollKCard
              ImageSrc={Fnollk}
              Title={"FnollK"}
              Web={"https://ftek.se/fnollk/"}
              Program={`Teknisk fysik 300 hp
              Teknisk matematik 300 hp`}
            />
          </Col>
          <Col style={colStyle}>
            <NollKCard
              ImageSrc={Gos}
              Title={"GØS"}
              Web={"https://www.globalasystem.se/mottagningen"}
              Program={`Globala System 300 hp`}
            />
          </Col>
          <Col style={colStyle}>
            <NollKCard
              ImageSrc={Hnollk}
              Title={"HNollK"}
              Web={"http://www.nollk.se"}
              Program={`Datateknik 180 hp
              Elektroteknik 180 hp
              Mekatronik 180 hp
              Ekonomi och produktionsteknik 180 hp`}
            />
          </Col>
          <Col style={colStyle}>
            <NollKCard
              ImageSrc={Inollk}
              Title={"INollK"}
              Web={"http://inollk.se/"}
              Program={`Industriell ekonomi 300 hp`}
            />
          </Col>
          <Col style={colStyle}>
            <NollKCard
              ImageSrc={Kok}
              Title={"KØK"}
              Web={"http://knollk.se"}
              Program={`Teknisk Kemi 300 hp`}
            />
          </Col>
          <Col style={colStyle}>
            <NollKCard
              ImageSrc={Mnollk}
              Title={"MnollK"}
              Web={"http://mtek.chalmers.se/mnollk/"}
              Program={`Maskinteknik 180/300 hp`}
            />
          </Col>
          <Col style={colStyle}>
            <NollKCard
              ImageSrc={Nollkit}
              Title={"NollKIT"}
              Web={"https://nollk.it"}
              Program={`Informationsteknik 300 hp`}
            />
          </Col>
          <Col style={colStyle}>
            <NollKCard
              ImageSrc={Sjo}
              Title={"SJØK"}
              Web={"https://www.sjonollk.se/"}
              Program={`Internationell logistik 180 hp
              Sjöbefäl 60 hp
              Sjöingenjör 180 hp
              Sjökapten 180 hp`}
            />
          </Col>
          <Col style={colStyle}>
            <NollKCard
              ImageSrc={TBK}
              Title={"TBK"}
              Web={"https://tbkchalmers.se"}
              Program={`Tekniskt basår 60 fup`}
            />
          </Col>
          <Col style={colStyle}>
            <NollKCard
              ImageSrc={Tdnollk}
              Title={"TDnollK"}
              Web={"https://tdtek.chalmers.se/?page_id=31"}
              Program={`Teknisk design 180/300 hp`}
            />
          </Col>
          <Col style={colStyle}>
            <NollKCard
              ImageSrc={Vok}
              Title={"VØK"}
              Web={"https://www.vtek.se/foreningar-gamble/vnollk/"}
              Program={`Samhällsbyggnadsteknik 300 hp
              Samhällsbyggnadsteknik 180 hp`}
            />
          </Col>
          <Col style={colStyle}>
            <NollKCard
              ImageSrc={Zok}
              Title={"ZØK"}
              Web={"http://znollk.se"}
              Program={`Automation och mekatronik 300 hp`}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

const colStyle = {};

const paddingStyle = {
  marginTop: "10px",
};

const paddingTop = {
  marginTop: "50px",
};

export default NollK;
